import { createCustomEnum } from "./customEnum";

export type ReportTypeKeys = "Aurora House Accounts" | "Inside Sales";

const ReportType = createCustomEnum({
	AuroraHouseAccounts: {
		name: "Aurora House Accounts",
		value: "aurora_house_account",
		displayName: "Aurora House Accounts",
	},
	InsideSales: {
		name: "Inside Sales",
		value: "inside_sales",
		displayName: "Inside Sales",
	},
});

export default ReportType;
